export function withConfiguredEntityData(event = {}, configuredEntityData = {}) {
  if (Object.hasOwn(event, "entityData")) return event;
  return {
    ...event,
    entityData: configuredEntityData,
  };
}
